var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9916 0.305241C21.8466 0.187948 21.6772 0.104641 21.4957 0.0614445C21.3143 0.0182476 21.1255 0.0162588 20.9432 0.0556247L11.2331 2.23977L1.52304 0.0306631C1.33785 -0.011161 1.14557 -0.0101873 0.960816 0.0335096C0.776064 0.0772065 0.603716 0.162475 0.456888 0.282826C0.310061 0.403176 0.192624 0.555437 0.113515 0.728019C0.034407 0.9006 -0.00428748 1.08895 0.000376772 1.27875V16.5054C-0.00667444 16.7939 0.0864756 17.0759 0.263971 17.3035C0.441466 17.531 0.692337 17.69 0.973881 17.7535L10.9585 20H11.5077L21.4924 17.7535C21.7739 17.69 22.0248 17.531 22.2023 17.3035C22.3798 17.0759 22.4729 16.7939 22.4659 16.5054V1.27875C22.465 1.09128 22.4219 0.906412 22.3398 0.737878C22.2577 0.569344 22.1387 0.421471 21.9916 0.305241ZM2.49654 2.83885L9.98504 4.52376V17.1918L2.49654 15.5069V2.83885ZM19.9697 15.5069L12.4812 17.1918V4.52376L19.9697 2.83885V15.5069Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c0565ed1.svg";
export { ForwardRef as ReactComponent };